/**
 * The different types of SKUS for the application.
 *
 * @type {Object}
 */
export const SKU_TYPES = {
    SYSTEM: 'SYSTEM',
    COMMERCIAL: 'COMMERCIAL',
};

export const BENEFITS_DOCUMENT_CREATOR_SKU = {
    KEY: 'benefits-document-creator',
    VALUE: 'Benefits Documents Creator',
};

export const HANDBOOKS_SKU = {
    KEY: 'handbooks',
};

export const EHS_SKU = {
    EHS_CLIENT_BASIC_KEY: 'ehsclientbasic',
    EHS_CLIENT_PREMIUM_KEY: 'ehsclientpremium',
    EHS_COSMIC_KEY: 'ehscosmic',
    EHS_PARTNER_KEY: 'ehspartner',
    EHS_DEMO_KEY: 'ehsdemo',
};
